"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getContentOfFirstTagOfName(document, name) {
    var tagCollection = document.getElementsByTagName(name);
    if (tagCollection.length === 0) {
        return null;
    }
    var firstTagElement = tagCollection[0];
    return firstTagElement.textContent;
}
function extractRequestHeaders(parsedLicenseMessage) {
    var headers = {};
    var httpHeaders = parsedLicenseMessage.getElementsByTagName('HttpHeader');
    for (var i = 0; i < httpHeaders.length; i++) {
        var httpHeader = httpHeaders[i];
        var name_1 = getContentOfFirstTagOfName(httpHeader, 'name');
        var value = getContentOfFirstTagOfName(httpHeader, 'value');
        if (name_1 && value) {
            headers[name_1] = value;
        }
    }
    return headers;
}
function decodeUint16(message) {
    return String.fromCharCode.apply(null, new Uint16Array(message.buffer));
}
function generatePlayreadyLicenseRequest(drmConfiguration, message, messageType, decodeMessage, domParser, decodeBase64) {
    if (decodeMessage === void 0) { decodeMessage = decodeUint16; }
    if (domParser === void 0) { domParser = DOMParser; }
    if (decodeBase64 === void 0) { decodeBase64 = atob; }
    var decodedMessage = decodeMessage(message);
    var parsedLicenseMessage = new domParser().parseFromString(decodedMessage, 'text/xml');
    var challenge = getContentOfFirstTagOfName(parsedLicenseMessage, 'Challenge');
    var decodedChallenge = decodeBase64(challenge);
    var licenseUrl = drmConfiguration.licenceAcquisitionUrl;
    return {
        url: licenseUrl,
        method: 'POST',
        body: decodedChallenge,
        headers: extractRequestHeaders(parsedLicenseMessage),
    };
}
exports.default = generatePlayreadyLicenseRequest;
